import { render } from "./EditAccessPage.vue?vue&type=template&id=67eb529c&ts=true"
import script from "./EditAccessPage.vue?vue&type=script&lang=ts"
export * from "./EditAccessPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\GitHub\\lexoh-parking-ionic\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__